import React from "react";
import QRCode from "react-qr-code";
import { Loader2 } from "lucide-react";
import { ContractDialog } from "./ContractReviewUi";
import bankIdLogo from "../../assets/partners/bankid-logo.png";

// Uses the real signing modal's existing state and callbacks. No BankID lifecycle here.
export default function ContractBankIdDialog({ open, title, subtitle, t, subTab, setSubTab, step, qrContent, hintText, error, autoStartToken, onCancel, onOpenOnDevice, onRetry }) {
  return (
    <ContractDialog open={open} onOpenChange={(next) => { if (!next) onCancel(); }} title={title} description={subtitle} wide={false}>
      <div className="ds-contract-bankid">
        <img src={bankIdLogo} alt="BankID" className="ds-contract-bankid-mark" />
        <div className="ds-contract-bankid-tabs" role="tablist" aria-label="BankID">
          {["scanQr", "thisDevice"].map((key, index) => (
            <button key={key} type="button" role="tab" id={`contract-bankid-tab-${index}`} aria-selected={subTab === index} aria-controls="contract-bankid-panel" tabIndex={subTab === index ? 0 : -1}
              onClick={() => setSubTab(index)} onKeyDown={(event) => {
                if (["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) {
                  event.preventDefault();
                  const next = event.key === "Home" ? 0 : event.key === "End" ? 1 : 1 - index;
                  setSubTab(next);
                  document.getElementById(`contract-bankid-tab-${next}`)?.focus();
                }
              }}>
              {t(`auth.bankId.${key}`)}
            </button>
          ))}
        </div>
        <div role="tabpanel" id="contract-bankid-panel" aria-labelledby={`contract-bankid-tab-${subTab}`}>
          {subTab === 0 ? (
            <>
              <div className="ds-contract-bankid-qr">
                {step === "polling" && qrContent ? <QRCode value={qrContent} size={220} /> : <Loader2 className="animate-spin" size={28} aria-label={t("auth.bankId.waiting")} />}
              </div>
              <p className="ds-doc-prose">{t("auth.bankId.scanQrInstruction")}</p>
            </>
          ) : <p className="ds-panel-note">{t("auth.bankId.openAppHint")}</p>}
          <p className="ds-contract-bankid-hint" role="status" aria-live="polite">{hintText}</p>
          {error && <p className="ds-error-text" role="alert">{error}</p>}
          <div className="ds-contract-dialog-actions">
            <button type="button" className="ds-action-outline" onClick={onCancel}>{t("auth.bankId.cancel")}</button>
            {subTab === 0 && step === "idle" && onRetry && (
              <button type="button" className="ds-action-ink" onClick={onRetry}>{t("auth.bankId.tryAgain")}</button>
            )}
            {/* Opens the app on iPhone/iPad (which only allow the user's own tap) and is the fallback
                elsewhere if the automatic launch was blocked; after a failure it starts a new order. */}
            {subTab === 1 && (
              <button type="button" className="ds-action-ink" onClick={onOpenOnDevice} disabled={step === "polling" && !autoStartToken}>
                {step === "polling" && !autoStartToken && <Loader2 size={18} className="animate-spin" aria-hidden="true" />}
                {t(step === "polling" && !autoStartToken ? "auth.bankId.waiting" : "auth.bankId.openBankIdApp")}
              </button>
            )}
          </div>
        </div>
      </div>
    </ContractDialog>
  );
}
